document.addEventListener('DOMContentLoaded', function () {
    const stickyContainer = document.querySelector('.sticky-add-to-cart');
    const signUpToPurchase = document.querySelector('.sticky-add-to-cart set-product-to-add-on-redirect');
    const stickyButton = document.getElementById('sticky-add-to-cart');
    const mainButton = document.querySelector('form[action="/cart/add"] button');
    const cartDrawer = document.querySelector('cart-drawer');
    const productModal = document.querySelector('product-modal');
    const swymWishListButton = document.getElementById('swym-atw-pdp-button');
    const wishListButton = document.querySelector('button.wishlist');
    const wishListIcon = document.querySelector('button.wishlist svg path');

    stickyButton?.addEventListener('click', () => {
      document.cookie = 'atc-source=stickyATC; path=/; max-age=10';
      mainButton.click();
    });

    wishListButton?.addEventListener('click', () => {
      if (swymWishListButton) {
        swymWishListButton.click();
      }
    });

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(swat) {
      // Added to wishlist
      swat.evtLayer.addEventListener('sw:addedtowishlist', function(e) {
        wishListIcon.classList.add("is-active");
      });

      // Removed from wishlist
      swat.evtLayer.addEventListener('sw:removedfromwishlist', function(e) {
        wishListIcon.classList.remove("is-active");
      });
    });

    if (!stickyContainer || !mainButton) return;

    // Intersection Observer options
    const observerOptions = {
      root: null, // viewport
      threshold: 0, // trigger when any part is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Main button is visible → hide sticky
          stickyContainer.classList.remove('show');
        } else {
          // Main button not visible → show sticky
          stickyContainer.classList.add('show');
        }
      });
    }, observerOptions);

    observer.observe(mainButton);

    // Watch for cart drawer state changes (open/close)
    if (cartDrawer) {
      const drawerObserver = new MutationObserver(() => {
        updateStickyButton();
      });
      drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    // --- Observe product modal open/close changes ---
    if (productModal) {
      const modalObserver = new MutationObserver(() => {
        updateStickyButton();
      });
      modalObserver.observe(productModal, { attributes: true, attributeFilter: ['open'] });
    }

    // observe main wishlist button
    if (swymWishListButton) {
      const wishListObserver = new MutationObserver(() => {
        const svg = swymWishListButton.querySelector('svg');
        const path = svg ? svg.querySelector('path') : null;

        if (!path) return;

        const fill = getComputedStyle(path).fill;
        const isInWishlist = fill === 'rgb(16, 16, 16)';

        // Update your icon state
        if (isInWishlist) {
          wishListIcon.classList.add("is-active");
        } else {
          wishListIcon.classList.remove("is-active");
        }
      });

      wishListObserver.observe(swymWishListButton, {
        subtree: true,            // observe SVG + inside path
        childList: true,          // observe replacing SVG nodes
        attributes: true,         // observe attribute changes on svg/path
        attributeFilter: ['fill', 'style'] // what you want
      });
    }

    function updateStickyButton() {
      const isDrawerActive = cartDrawer?.classList.contains('active');
      const isModalOpen = productModal?.hasAttribute('open');
      const shouldShow = !isDrawerActive && !isModalOpen && (signUpToPurchase || mainButton);

      stickyContainer.style.display = shouldShow ? 'flex' : 'none';
    }
});
